module.exports = __webpack_public_path__ + "static/media/application_8.87b49607.png";